/** Coordinates client-side bulk approval for the Image Audit queue. */

export type ImageAuditApprovalResult = {
   approvedCount: number
   failedCount: number
}

/** Approves each queued image in order and reports progress after every attempt. */
export const approveAuditImages = async (
   imageIds: string[],
   approve: (imageId: string) => Promise<unknown>,
   onProgress: (completed: number) => void
): Promise<ImageAuditApprovalResult> => {
   let approvedCount = 0;
   let failedCount = 0;

   for (const imageId of imageIds) {
      try {
         await approve(imageId);
         approvedCount += 1;
      } catch {
         failedCount += 1;
      }
      onProgress(approvedCount + failedCount);
   }

   return {approvedCount, failedCount};
}
